import Crown from '@assets/icons/crown.svg'
import { Icon } from './Icon'

export const CrownIcon = Icon(Crown)
